export enum NumberFormatType {
  currency = 'currency',
  percent = 'percent',
}
